import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Wine } from "lucide-react";

export default function Login() {
  const { login, error } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await login(email, password);
    setLoading(false);
    if (ok) navigate("/");
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#0a0c10]">
      <div
        className="hidden lg:block relative"
        style={{
          backgroundImage:
            "linear-gradient(135deg, rgba(10,12,16,0.6), rgba(10,12,16,0.92)), url('https://images.pexels.com/photos/9566294/pexels-photo-9566294.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 flex flex-col justify-between p-12">
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-md bg-amber-500 flex items-center justify-center">
              <Wine className="w-5 h-5 text-black" />
            </div>
            <div className="font-display text-xl font-bold">
              Barkeep<span className="text-amber-500">.</span>
            </div>
          </div>
          <div>
            <div className="font-display text-4xl lg:text-5xl font-bold leading-tight max-w-md">
              Every bottle. <span className="text-amber-500">Accounted for.</span>
            </div>
            <p className="text-slate-400 mt-4 max-w-md">
              Automated ordering, live consumption tracking and AI reorder
              intelligence for modern bars.
            </p>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center px-6 py-16">
        <form
          onSubmit={handleSubmit}
          className="w-full max-w-sm space-y-6"
          data-testid="login-form"
        >
          <div>
            <div className="text-xs uppercase tracking-widest text-amber-500 font-mono-plex mb-3">
              Welcome back
            </div>
            <h1 className="font-display text-3xl font-bold">Sign in</h1>
            <p className="text-slate-500 text-sm mt-1">
              Access your bar's inventory command center.
            </p>
          </div>

          <div className="space-y-3">
            <div>
              <label className="text-xs text-slate-400 mb-1 block">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email"
                className="w-full bg-[#12141a] border border-white/10 rounded-md px-3 py-2.5 text-white outline-none focus:border-amber-500 focus:ring-1 focus:ring-amber-500"
                placeholder="you@bar.com"
              />
            </div>
            <div>
              <label className="text-xs text-slate-400 mb-1 block">
                Password
              </label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password"
                className="w-full bg-[#12141a] border border-white/10 rounded-md px-3 py-2.5 text-white outline-none focus:border-amber-500 focus:ring-1 focus:ring-amber-500"
                placeholder="••••••••"
              />
            </div>
          </div>

          {error && (
            <div
              className="text-sm text-red-400 bg-red-500/10 border border-red-500/20 rounded-md px-3 py-2"
              data-testid="login-error"
            >
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="btn-amber w-full rounded-md py-2.5 disabled:opacity-60"
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>

          <div className="text-sm text-slate-500 text-center">
            No account yet?{" "}
            <Link
              to="/register"
              className="text-amber-500 hover:text-amber-400"
              data-testid="go-to-register"
            >
              Create one
            </Link>
          </div>
          <div className="text-xs text-slate-600 text-center font-mono-plex pt-2 border-t border-white/5">
            Demo: admin@barinventory.com / Admin123!
          </div>
        </form>
      </div>
    </div>
  );
}
